/**
 * 場所詳細シート (Visit版)
 *
 * Visitに紐付いた場所の詳細情報を表示（共通コンポーネントのラッパー）
 */

import { MapPin } from 'lucide-react'

import type { OverlandVisit } from '@/api/types/overland'
import { Button } from '@/components/ui/button'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet'

import { PlaceSheet } from '../place-sheet'

type Props = {
  visit: OverlandVisit
  open: boolean
  onOpenChange: (open: boolean) => void
  onEditClick: () => void
  /** この訪問での買い物を、レシートなしで手で登録する */
  onAddReceiptClick?: () => void
}

export const PlaceDetailSheet = ({ visit, open, onOpenChange, onEditClick, onAddReceiptClick }: Props) => {
  const place = visit.place

  // 場所が未設定の場合
  if (!place) {
    return (
      <Sheet open={open} onOpenChange={onOpenChange}>
        <SheetContent side="bottom" className="h-[50vh] rounded-t-2xl">
          <SheetHeader>
            <SheetTitle>場所未設定</SheetTitle>
          </SheetHeader>
          <div className="flex flex-col items-center justify-center h-full gap-4">
            <MapPin className="size-12 text-muted-foreground opacity-50" />
            <p className="text-muted-foreground text-sm">この訪問には場所が設定されていません</p>
            <Button onClick={onEditClick}>場所を設定</Button>
          </div>
        </SheetContent>
      </Sheet>
    )
  }

  return (
    <PlaceSheet
      place={place}
      visit={visit}
      open={open}
      onOpenChange={onOpenChange}
      onEditClick={onEditClick}
      onAddReceiptClick={onAddReceiptClick}
    />
  )
}
